var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: #fff;\n      }\n    ")),React.createElement("path",{"id":"ic_filter_list_24px","className":"cls-1","d":"M7.214,13.224H9.622v-1.2H7.214ZM3,6V7.2H13.836V6Zm1.806,4.214H12.03V9.01H4.806Z","transform":"translate(-3 -6)","key":1})]);
}

Filter.defaultProps = {"viewBox":"0 0 10.836 7.224"};

module.exports = Filter;

Filter.default = Filter;
